import { render, staticRenderFns } from "./WineProductPage.vue?vue&type=template&id=4fa568ec&scoped=true"
import script from "./WineProductPage.vue?vue&type=script&lang=js"
export * from "./WineProductPage.vue?vue&type=script&lang=js"
import style0 from "./WineProductPage.vue?vue&type=style&index=0&id=4fa568ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa568ec",
  null
  
)

export default component.exports